import { useMutation, useQuery } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { Alert } from "components/base/Toast";
import OdooPOPreview from "components/shared/OdooPOPreview";
import { v4 } from "uuid";
import { SYNC_PLAN_TO_ODOO } from "../syncPlanToOdooViews/graphql";
import { FETCH_PLAN_SUMMARY_AND_ODOO_PO_DETAIL } from "./graphql";

const SyncPlanToPoView = ({ planId, poId }) => {
  const { loading, error, data } = useQuery(
    FETCH_PLAN_SUMMARY_AND_ODOO_PO_DETAIL,
    {
      variables: { id: planId, poId },
      fetchPolicy: "network-only",
    },
  );
  const [send, sendRes] = useMutation(SYNC_PLAN_TO_ODOO, {
    variables: { planId, instance: "INC", orderType: "PO" },
    onCompleted() {
      Alert("success", "Plan sync to Odoo SO successfully");
    },
    onError(error) {
      Alert("error", parseError(error));
    },
    refetchQueries: [FETCH_PLAN_SUMMARY_AND_ODOO_PO_DETAIL],
    awaitRefetchQueries: true,
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const parsedOdooPo = data.odooPo ? JSON.parse(data.odooPo) : [];
  const odooPo = Array.isArray(parsedOdooPo) ? parsedOdooPo[0] : null;

  console.log("odooPo", odooPo);

  const orderLines = data.productionPlan.finalLines.reduce((res, i) => {
    const found = res.find(
      (x) =>
        x.productId === i.product.odooIdInc &&
        x.salesPrice === i.salesPrice &&
        x.discountPercentage === i.discountPercentage,
    );
    if (found)
      return res.map((x) =>
        x.id === found.id
          ? {
              ...x,
              qty: x.qty + i.finalQty,
              totalPrice: x.totalPrice + i.totalPrice,
            }
          : x,
      );

    return [
      ...res,
      {
        id: v4(),
        productId: i.product.odooIdInc,
        name: `[${i.product.number}] ${i.product.name}`,
        qty: i.finalQty,
        salesPrice: i.salesPrice,
        discountPercentage: i.discountPercentage,
        totalPrice: i.totalPrice,
        odooQty: 0,
        price_subtotal: 0,
      },
    ];
  }, []);

  console.log("orderLines", orderLines);

  odooPo?.order_line?.forEach((line) => {
    const found = orderLines.find(
      (x) =>
        x.productId === line.product_id.id &&
        x.salesPrice === line.price_unit &&
        x.discountPercentage === line.discount,
    );
    if (found) {
      found.odooQty += line.product_qty;
    } else {
      orderLines.push({
        id: v4(),
        productId: line.product_id.id,
        name: line.product_id.display_name,
        qty: 0,
        salesPrice: line.price_unit,
        discountPercentage: line.price_subtotal,
        odooQty: line.product_qty,
        totalPrice: line.price_subtotal,
      });
    }
  });

  console.log("odooPo", odooPo);

  const isSynced = orderLines.every((line) => line.odooQty === line.qty);

  return (
    <div className="space-y-6 text-sm">
      <div className="card">
        <OdooPOPreview orderLines={orderLines} compareOdoo />
      </div>

      <div>
        {!odooPo ? (
          <div className="text-pink-600 mx-1 text-center font-semibold">
            ⚠️ PO not found in Odoo, cannot sync.
          </div>
        ) : odooPo.state === "draft" ? (
          isSynced ? (
            <div className="text-green-600 font-semibold">
              ✅ This plan is already Synced with Odoo PO: {odooPo.name}.
            </div>
          ) : (
            <Button primary onClick={send} loading={sendRes.loading}>
              Sync to Order {odooPo.name}
            </Button>
          )
        ) : (
          <div className="text-pink-600 mx-1 text-center font-semibold">
            <p>⚠️ The PO is not in Draft state, wis cannot sync anymore.</p>
            <p>
              To avoid unexpected data change in Odoo, please manually update
              the PO in Odoo.
            </p>
            <p>If you have any question, please contact the support team.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SyncPlanToPoView;
